var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 25.375C15.2837 25.375 16.3337 24.325 16.3337 23.0417H11.667C11.667 24.325 12.717 25.375 14.0003 25.375ZM21.0003 18.375V12.5417C21.0003 8.96 19.0987 5.96167 15.7503 5.16833V4.375C15.7503 3.40667 14.9687 2.625 14.0003 2.625C13.032 2.625 12.2503 3.40667 12.2503 4.375V5.16833C8.91366 5.96167 7.00033 8.94833 7.00033 12.5417V18.375L4.66699 20.7083V21.875H23.3337V20.7083L21.0003 18.375ZM18.667 19.5417H9.33366V12.5417C9.33366 9.64833 11.0953 7.29167 14.0003 7.29167C16.9053 7.29167 18.667 9.64833 18.667 12.5417V19.5417Z",
    fill: "#616161"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.417,
    cy: 7.58301,
    r: 5.25,
    fill: "#00D095"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.ae5715e901404e6b743b9e73d7783e4f.svg";
export { ForwardRef as ReactComponent };